import { render } from "./ResetPassword.vue?vue&type=template&id=7bb60f3e&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=7bb60f3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7bb60f3e"

export default script